import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import { Home } from '../../interfaces/page';
import { WordpressService } from '../../services/wordpress.service';
import { JournalPost } from '../../interfaces/journal-post';

@Component({
  selector: 'app-home-section-journal',
  templateUrl: './home-section-journal.component.html',
  styleUrls: ['./home-section-journal.component.scss']
})
export class HomeSectionJournalComponent implements OnInit, OnDestroy {
  @Input() content: Home;
  posts: JournalPost[] = [];
  postSubscription;

  constructor(
    private wp: WordpressService
  ) {
  }

  ngOnInit() {
    // Need to grab ACF data for selected posts
    if (this.content && this.content.journal_section && this.content.journal_section.posts) {
      this.content.journal_section.posts.forEach(post => {
        this.postSubscription = this.wp.getJournalPost(post.post_name).subscribe(res => {
          if (res && res.length) {
            this.posts.push(res[0]);
          }
        });
      });
    }
  }

  ngOnDestroy() {
    this.posts = [];
    if (this.postSubscription) {
      this.postSubscription.unsubscribe();
    }
  }
}
